import {storeProducts, StoreProducts} from "./products/IInvestStoreProductsComponents";
import {storeConfirm, StoreConfirm} from "./confirm/IInvestStoreConfirmComponent";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.store.iinvest.components", [])
                  .component(StoreProducts, storeProducts(rootDir))
                  .component(StoreConfirm, storeConfirm(rootDir))
                  .name;
}
